export const LOGIN_PAGE_KEY = "LOGIN_PAGE_STATE";



// WEBPACK FOOTER //
// ./src/modules/session/constants.js